import { createFileRoute, useNavigate } from '@tanstack/react-router';
import LockUp from '../../assets/brand/lock-up.svg';
import { Loader } from '@sc/shared-ui';
import { useApolloClient, useQuery } from '@apollo/client/react';
import { GQL_QUERY_LOGOUT } from '../../utility/queries';
import { useEffect } from 'react';
import { useAuthenticated } from '../../providers/authenticated';
import { resetAnalytics } from '../../utility/analytics';

export const Route = createFileRoute('/_unauthenticated/logout')({
  component: RouteComponent,
});

function RouteComponent() {
  const { data } = useQuery(GQL_QUERY_LOGOUT);
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuthenticated();

  const client = useApolloClient();

  useEffect(() => {
    if (data) {

      client.defaultContext.accessToken = undefined;

      resetAnalytics();

      void client.clearStore().then(() => {
        sessionStorage.clear();

        localStorage.clear();
          
        setIsAuthenticated(null);

        void navigate({
          to: '/login',
        });
      });
    }
  }, [client, data, navigate, setIsAuthenticated]);

  return (
    <div className="h-full w-full px-5 py-10 flex flex-col items-center justify-center">
      <div className="w-full max-w-105 flex flex-col gap-10 items-center">
        <LockUp className="h-5" />
        <div className="w-full flex flex-col items-center space-y-3">
          <h1 className="font-grotesque font-semibold text-h1 leading-11 text-center mb-4">
            Signing out...
          </h1>
          <p className="text-text-low-priority text-center mb-8">
            See you next time!
          </p>
          <Loader className="size-5" />
        </div>
      </div>
    </div>
  );
}
